import { useState } from 'react';
import { api } from '../lib/api';

interface EmailVerificationBannerProps {
  user: any;
}

export default function EmailVerificationBanner({ user }: EmailVerificationBannerProps) {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (!user || user.emailVerified || dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await api.auth.resendVerification();
      setSent(true);
    } catch (err) {
      console.error('Resend failed:', err);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-amber-900/30 border-b border-amber-800/50">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-sm">
          <svg className="w-4 h-4 text-amber-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
          <span className="text-amber-200">
            Please verify your email address to unlock all features.
            {sent && (
              <span className="ml-2 text-amber-300/80">
                (Check your <strong>Spam</strong> or <strong>Junk</strong> folder if you don't see it.)
              </span>
            )}
          </span>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          {sent ? (
            <span className="text-xs text-emerald-400">Verification email sent!</span>
          ) : (
            <button
              onClick={handleResend}
              disabled={sending}
              className="text-xs px-3 py-1 bg-amber-700/50 hover:bg-amber-700 text-amber-200 rounded-lg transition-colors disabled:opacity-50"
            >
              {sending ? 'Sending...' : 'Resend Email'}
            </button>
          )}
          <button
            onClick={() => setDismissed(true)}
            className="text-amber-400/60 hover:text-amber-300 transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
